export const isEnvSandbox = process.env.REACT_APP_ENVIRONMENT === 'sandbox';
